import { Dialogs } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import ViewAssociatedIdsDialog from "../apiAccessKey/ViewAssociatedIdsDialog.js";
const {
  t,
  tf,
  tIcon
} = I18N.ns('apiAccessKeyManagement.action.ViewAssociatedIds');
export default {
  id: 'apiAccessKeyManagement.action.ViewAssociatedIds',
  type: 'ApiAccessKeys.ViewAssociatedIds',
  name: tf('name'),
  layout: {
    sort: 'associatedIds.a',
    // presence of '.' causes section grouping behavior
    sectionName: tf('sectionName')
  },
  matches: {
    use: 'contextMenu',
    client: 'ApiAccessKeys'
  },
  handles: context => {
    return true;
  },
  appearance: opts => {
    const name = t('appearanceName');
    const icon = tIcon('info', '@icon:associated-id');
    return {
      name,
      icon
    };
  },
  perform: ({
    context
  }) => {
    const {
      clientProps: {
        delegate,
        variants
      },
      uiName
    } = context;
    Dialogs.show({
      component: ViewAssociatedIdsDialog,
      props: {
        delegate,
        variants,
        uiName
      }
    });
  }
};